class VoiceService {
  private recognition: any = null;
  private synthesis: SpeechSynthesis | null = null;
  private isRecording = false;
  private isSupported = false;

  constructor() {
    this.checkSupport();
  }

  private checkSupport() {
    // Verificar suporte para SpeechRecognition
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    this.synthesis = window.speechSynthesis;
    
    this.isSupported = !!(SpeechRecognition && this.synthesis);
  }

  isVoiceSupported(): boolean {
    return this.isSupported;
  }

  startRecording(onResult: (text: string) => void, onError: (error: string) => void): void {
    if (!this.isSupported) {
      onError('Funcionalidade de voz não suportada neste navegador');
      return;
    }

    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    this.recognition = new SpeechRecognition();
    
    this.recognition.continuous = false;
    this.recognition.interimResults = false;
    this.recognition.lang = 'pt-BR';

    this.recognition.onstart = () => {
      this.isRecording = true;
    };

    this.recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      this.isRecording = false;
      onResult(transcript);
    };

    this.recognition.onerror = (event: any) => {
      this.isRecording = false;
      onError('Erro na gravação: ' + event.error);
    };

    this.recognition.onend = () => {
      this.isRecording = false;
    };

    try {
      this.recognition.start();
    } catch (error) {
      onError('Erro ao iniciar gravação');
    }
  }

  stopRecording(): void {
    if (this.recognition && this.isRecording) {
      this.recognition.stop();
    }
  }

  isCurrentlyRecording(): boolean {
    return this.isRecording;
  }

  speak(text: string, onStart?: () => void, onEnd?: () => void): void {
    if (!this.synthesis) {
      console.error('Speech synthesis não suportado');
      return;
    }

    // Cancelar qualquer fala em andamento
    this.synthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'pt-BR';
    utterance.rate = 0.9;
    utterance.pitch = 1;
    utterance.volume = 0.8;

    utterance.onstart = () => {
      if (onStart) onStart();
    };

    utterance.onend = () => {
      if (onEnd) onEnd();
    };

    utterance.onerror = (event) => {
      console.error('Erro na síntese de voz:', event);
    };

    this.synthesis.speak(utterance);
  }

  stopSpeaking(): void {
    if (this.synthesis) {
      this.synthesis.cancel();
    }
  }

  isSpeaking(): boolean {
    return this.synthesis ? this.synthesis.speaking : false;
  }

  // Função para transcrever texto para voz (opcional)
  transcribeToVoice(text: string): void {
    this.speak(text);
  }
}

export const voiceService = new VoiceService(); 